// Shared token-bucket rate limiter for capture paths (network / WebSocket
// event floods). Kept tiny on purpose — callers count their own drops.

export interface TokenBucket {
  /** Spend one token if available; false = the caller should drop the event. */
  take(): boolean;
}

/** A token bucket: refills at `rate` tokens/sec (sustained), holds at most
 *  `burst` tokens (burst capacity). */
export function tokenBucket(rate: number, burst: number): TokenBucket {
  let tokens = burst;
  let last = Date.now();
  return {
    take() {
      const now = Date.now();
      tokens = Math.min(burst, tokens + ((now - last) / 1000) * rate);
      last = now;
      if (tokens < 1) return false;
      tokens -= 1;
      return true;
    },
  };
}
